// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Message Logs: local dropdown under the icon (no CDK overlay). */
.badmessage-logs-menu-wrap {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.badmessage-logs-menu-trigger {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: #17a2b8;
  cursor: pointer;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.badmessage-logs-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1050;
  min-width: 140px;
  margin-top: 4px;
  padding: 4px 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.badmessage-logs-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}

.badmessage-logs-dropdown-item:hover {
  background: rgba(0, 0, 0, 0.04);
}

ngx-monaco-editor {
  width: 100%;
  height: 350px;
}

.font_size {
  font-size: 12px !important;
}

.ng-autocompleteroutr {
  width: 370px;
}

.search_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.reset_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
}

::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -3% !important;
  margin-left: 2% !important;
}

.link_Nonhighlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 85% !important;
  display: inline-block;
}

.link_highlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  margin-right: 1%;
}

.link_highlight:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb;
  padding-inline: 3%;
  padding-block: 2px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

.iconCheck {
  font-size: 12px;
  position: relative;
  top: -20%;
  margin-left: -3px;
}

.hubmessageList ::ng-deep .mat-ink-bar {
  background-color: rgba(0, 0, 0, 0) !important;
}
.hubmessageList ::ng-deep .mat-tab-label {
  height: 30px !important;
  opacity: unset !important;
  padding-inline: 1% !important;
}
.hubmessageList ::ng-deep .mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px 10px;
  background-color: #12127c;
  color: white;
  font-weight: 700;
  opacity: unset;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.hubmessageList ::ng-deep .mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: black;
  font-weight: 700;
}

::ng-deep .mat-tab-body-content {
  overflow-x: hidden !important;
}

.doller {
  position: absolute;
  top: -11px;
  left: 15%;
}

.textCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-success {
  color: #5dd077 !important;
}

.text-danger {
  color: #da606c !important;
}

.gui_ellipsis {
  font-weight: 600;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.pipeline_ellipsis {
  max-width: 89%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  top: 8%;
  left: 1%;
  padding-right: 1%;
}

.trans_ellipsis {
  max-width: 74%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 11%;
  padding-right: 1%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.iconPointer:hover {
  pointer-events: all;
}

.arrow_source {
  left: 5%;
  width: 97%;
  height: 2px;
  background-color: grey;
  position: relative;
  top: 36%;
}

.arr_chev {
  position: relative;
  text-align: right !important;
  right: -98%;
  color: grey;
  top: -9px;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.healing_card {
  border-left: 4px solid #f5a700;
}

.border-gradient {
  border-left: 4px solid !important;
  border-image-slice: 1;
  border-block: 0;
  border-right: 0;
}

.border-gradient-redgreen {
  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 15px;
}

.pipeline_label {
  float: left;
  padding-right: 11%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 100%;
}

.source_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 100%;
}

.target_label {
  float: left;
  padding-right: 13%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 100%;
}

.processor_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.processor_feild {
  float: left;
  width: 100%;
}

.message_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.message_feild {
  float: left;
  width: 100%;
}

.transaction_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.message_type_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.message_type {
  width: 100%;
  height: 30px;
  position: relative;
}

.messagefield_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.messagefield_feild {
  float: left;
  width: 100%;
}

.btnsdiv {
  padding-left: 16%;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 8px;
  }
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 8px;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .message_type {
    width: 53%;
    height: 35px;
    position: relative;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 85%;
  }
  .trans_ellipsis {
    max-width: 65%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .pipeline_feild {
    float: left;
    width: 100%;
  }
  .source_label {
    float: left;
    padding-right: 6%;
    position: relative;
    top: 0px;
  }
  .source_feild {
    float: left;
    width: 100%;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 0px;
  }
  .target_feild {
    float: left;
    width: 100%;
  }
  .processor_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
  }
  .message_feild {
    float: left;
    width: 100%;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .message_type {
    width: 86%;
    height: 35px;
    position: relative;
  }
  .reset_btn {
    padding-inline: 13% !important;
  }
  .gui_ellipsis {
    font-weight: 600;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 81%;
  }
  .trans_ellipsis {
    max-width: 52%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
.rightalign {
  float: right;
  padding-right: 60px;
  padding-top: 10px;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 12px;
}

::ng-deep.messageiot .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 12px;
}

::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 12px;
}

.messagestatus {
  position: relative;
  top: -3px;
}

.dot {
  height: 19px;
  width: 21px;
  background-color: #17a0b4 !important;
  border-radius: 100%;
  display: inline-block;
}

.name_feild {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: left;
  font-size: 12px !important;
  height: 30px !important;
  padding-left: 5px;
}
.name_feild input::placeholder {
  font-size: 12px !important;
}

.name_feild::placeholder {
  font-size: 12px !important;
}

::ng-deep.badmessagereprocess .modal-dialog .modal-content .modal-footer {
  display: unset !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: flex-end !important;
  padding: 0.3rem !important;
  border-top: 1px solid #dee2e6 !important;
  border-bottom-right-radius: calc(0.3rem - 1px) !important;
  border-bottom-left-radius: calc(0.3rem - 1px) !important;
}

::ng-deep.badmessagereprocess .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.monaco-editor {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -15px !important;
  right: 0;
}

.transaction_feild {
  float: left;
  font-size: 12px !important;
  height: 9.5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.badmsg_name_text {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.badmsg_text {
  color: black;
  top: 7px;
}

::ng-deep.msgrep.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 3%;
  bottom: 9%;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

::ng-deep.msgreplist.mat-mdc-checkbox {
  padding-left: 0 !important;
  padding-right: 0px !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

.custom-autocomplete-input {
  /* Add styles to make the input field resemble an autocomplete component */
  border-radius: 5px;
  border: 1px solid #f2f4f7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.21); /* Add box shadow */
  font-size: 12px !important;
  font-size: 12px !important;
  height: 9.5vh;
  float: left;
  width: 100%;
}

::ng-deep.myCustomModalViewfileBadMessage .modal-dialog {
  max-width: 84vw !important;
  width: 84vw !important;
  max-height: 77vh !important;
  height: 75vh !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
  left: 2% !important;
  top: 0% !important;
  margin: 0 !important;
}
::ng-deep.myCustomModalViewfileBadMessage .modal-content {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  height: 77vh;
}
::ng-deep.myCustomModalViewfileBadMessage .modal-body {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  height: 64vh !important;
}
::ng-deep.myCustomModalViewfileBadMessage .pdf-container {
  max-width: 100% !important;
  overflow: auto !important;
  overflow-x: hidden !important;
  height: 64vh !important;
}
::ng-deep.myCustomModalViewfileBadMessage .pdf-container .monaco-editor-containerr {
  height: 64vh !important;
}
::ng-deep.myCustomModalViewfileBadMessage .modal-body > div[style*="77vh"] {
  height: 64vh !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
}
::ng-deep.myCustomModalViewfileBadMessage ngx-monaco-editor {
  max-width: 100% !important;
  width: 100% !important;
}
::ng-deep.myCustomModalViewfileBadMessage ngx-monaco-editor .editor-container {
  max-width: 100% !important;
  overflow: hidden !important;
}
::ng-deep.myCustomModalViewfileBadMessage pdf-viewer {
  max-width: 100% !important;
  width: 100% !important;
}
::ng-deep.myCustomModalViewfileBadMessage div[style*="60vw"] {
  max-width: 100% !important;
  width: 100% !important;
}
::ng-deep.myCustomModalViewfileBadMessage .modal-body > div {
  max-width: 100% !important;
  width: 100% !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
}

::ng-deep.myCustomModalClass.badMessageViewModal {
  width: 88vw !important;
  max-width: 88vw !important;
  left: 12% !important;
  top: 16% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/badmessage/badmessage.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA,kEAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,yCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACI,WAAA;EACA,aAAA;AADJ;;AAIA;EACI,0BAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAGA;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;EACA,YAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,0BAAA;AAAJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AADJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AAAJ;;AAII;EACE,6CAAA;AADN;AAII;EAEE,uBAAA;EACA,yBAAA;EACA,6BAAA;AAHN;AAMI;EACE,0BAAA;EACA,iBAAA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;EACA,4BAAA;AAJR;AAMI;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;AAJN;;AAQE;EACE,6BAAA;AALJ;;AASA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;AANJ;;AAQA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AALJ;;AAOA;EACI,yBAAA;AAJJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AAHJ;;AAKA;EACI,8BAAA;AAFJ;;AAIA;EACI,8BAAA;AADJ;;AAGA;EACI,mBAAA;AAAJ;;AAEA;EACI,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AACJ;;AACA;EACI,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAEJ;;AAAA;EACI,8BAAA;AAGJ;;AADA;EACI,8BAAA;AAIJ;;AADA;EACI,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAIJ;;AAFA;EACI,iEAAA;AAKJ;;AAHA;EACI,eAAA;EACA,eAAA;EACA,eAAA;AAMJ;;AAHA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAMJ;;AAJA;EACI,WAAA;EACA,WAAA;AAOJ;;AAJA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAOJ;;AALA;EACI,WAAA;EACA,WAAA;AAQJ;;AALA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAQJ;;AANA;EACI,WAAA;EACA,WAAA;AASJ;;AANA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AASJ;;AAPA;EACI,WAAA;EACA,WAAA;AAUJ;;AARA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAWJ;;AATA;EACI,WAAA;EACA,WAAA;AAYJ;;AATA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAYJ;;AALA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAQJ;;AALA;EACI,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAQJ;;AANA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AASJ;;AAPA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAUJ;;AAPA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAUJ;;AARA;EACI,WAAA;EACA,WAAA;AAWJ;;AARA;EACI,iBAAA;AAWJ;;AARA;EACI;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAWN;EARE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAUN;EARE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAUN;EARE;IACI,WAAA;IACA,WAAA;EAUN;EAPE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EASN;EANE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAQN;EAFE;IACI,UAAA;IACA,YAAA;IACA,kBAAA;EAIN;EAFE;IACI,0BAAA;EAIN;EAFE;IACI,cAAA;EAIN;EAFE;IACI,cAAA;EAIN;EADM;IACI,qBAAA;EAGV;AACF;AACA;EACI;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EACN;EAEE;IACI,WAAA;IACA,WAAA;EAAN;EAEE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAAN;EAEE;IACI,WAAA;IACA,WAAA;EAAN;EAEE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAAN;EAEE;IACI,WAAA;IACA,WAAA;EAAN;EAEE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAAN;EAEE;IACI,WAAA;IACA,WAAA;EAAN;EAGE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EADN;EAGE;IACI,WAAA;IACA,WAAA;EADN;EAGE;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EADN;EAOE;IACI,UAAA;IACA,YAAA;IACA,kBAAA;EALN;EAQE;IACI,8BAAA;EANN;EASE;IACI,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAPN;EASE;IACI,0BAAA;EAPN;EASE;IACI,cAAA;EAPN;EASE;IACI,cAAA;EAPN;EAUM;IACI,qBAAA;EARV;AACF;AAYA;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;AAVJ;;AAaA;EACI,sBAAA;AAVJ;;AAaA;EACI,MAAA;EACA,sBAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,YAAA;AAVJ;;AAYA;EACI,UAAA;AATJ;;AAYA;EACI,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAVJ;;AAaA;EACI,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAVJ;;AAaA;EACI,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AAVJ;;AAaA;EACI,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAXJ;;AAcA;EACI,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAZJ;;AAeA;EACI,kBAAA;EACA,SAAA;AAZJ;;AAqBA;EACI,YAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,qBAAA;AAlBJ;;AAoBA;EACI,oDAAA;EACA,WAAA;EACA,0BCvmBO;EDwmBP,uBCrmBS;EDsmBT,iBAAA;AAjBJ;AAkBI;EACI,0BC3mBG;AD2lBX;;AAmBA;EACI,0BC/mBO;AD+lBX;;AAmBA;EACI,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,oCAAA;EACA,0BAAA;EACA,wCAAA;EACA,yDAAA;EACA,wDAAA;AAhBJ;;AAmBA;EACI,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAhBJ;;AAmBA;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,QAAA;AAjBJ;;AAqBA;EACE,WAAA;EACA,0BCjpBS;EDkpBT,aAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AAlBJ;;AAsBA;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAnBJ;;AAqBE;EACE,YAAA;EACE,QAAA;AAlBN;;AAqBE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAlBJ;AAmBI;EACE,WAAA;EACA,YAAA;AAjBN;AAkBM;EACE,gCCjrBI;EDkrBJ,oCClrBI;ADkqBZ;AAkBM;EACE,YAAA;AAhBR;AAmBI;EACE,YAAA;EACA,WAAA;AAjBN;;AAoBE;EACE,0BAAA;EACA,6BAAA;AAjBJ;AAkBI;EACI,WAAA;EACA,YAAA;AAhBR;AAiBQ;EACE,gCCpsBE;EDqsBF,oCCrsBE;ADsrBZ;AAiBQ;EACE,YAAA;AAfV;AAkBI;EACE,uBAAA;EACA,sBAAA;AAhBN;;AAmBE;EACE,0EAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA,EAAA,mBAAA;EACA,0BCptBO;EDqtBP,0BCrtBO;EDstBV,aAAA;EACA,WAAA;EACA,WAAA;AAhBD;;AAoBE;EACE,0BAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAjBJ;AAoBE;EACE,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;AAnBJ;AAuBE;EACE,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;AArBJ;AAsBI;EACI,uBAAA;AApBR;AAyBE;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;AAvBJ;AA4BE;EACE,0BAAA;EACA,sBAAA;AA1BJ;AA4BI;EACE,0BAAA;EACA,2BAAA;AA1BN;AA+BE;EACE,0BAAA;EACA,sBAAA;AA7BJ;AAiCE;EACE,0BAAA;EACA,sBAAA;AA/BJ;AAmCE;EACE,0BAAA;EACA,sBAAA;EACA,2BAAA;EACA,2BAAA;AAjCJ;;AAoCE;EACE,sBAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;AAjCJ","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n/* Message Logs: local dropdown under the icon (no CDK overlay). */\r\n.badmessage-logs-menu-wrap {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.badmessage-logs-menu-trigger {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: #17a2b8;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.badmessage-logs-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  z-index: 1050;\r\n  min-width: 140px;\r\n  margin-top: 4px;\r\n  padding: 4px 0;\r\n  background: #fff;\r\n  border: 1px solid rgba(0, 0, 0, 0.12);\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.badmessage-logs-dropdown-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: none;\r\n  background: transparent;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  font-size: 14px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.badmessage-logs-dropdown-item:hover {\r\n  background: rgba(0, 0, 0, 0.04);\r\n}\r\n\r\nngx-monaco-editor {\r\n    width: 100%;\r\n    height: 350px;\r\n}\r\n\r\n.font_size {\r\n    font-size: 12px !important;\r\n}\r\n\r\n.ng-autocompleteroutr {\r\n    width: 370px;\r\n}\r\n.search_btnss {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    border: none;\r\n    outline: none;\r\n}\r\n\r\n.reset_btnss {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    border: none;\r\n}\r\n\r\n::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n    margin-top: -3% !important;\r\n    margin-left: 2% !important;\r\n    // padding-bottom: 10% !important;\r\n}\r\n\r\n.link_Nonhighlight {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 85% !important;\r\n    display: inline-block;\r\n}\r\n\r\n.link_highlight {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 90% !important;\r\n    display: inline-block;\r\n    margin-right: 1%;\r\n}\r\n.link_highlight:hover {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 90% !important;\r\n    display: inline-block;\r\n    background-color: #3fa4fb;\r\n    padding-inline: 3%;\r\n    padding-block: 2px;\r\n    border-radius: 12px;\r\n    color: white !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.iconCheck {\r\n    font-size: 12px;\r\n    position: relative;\r\n    top: -20%;\r\n    margin-left: -3px;\r\n}\r\n\r\n.hubmessageList{\r\n    ::ng-deep .mat-ink-bar {\r\n      background-color: rgba(0, 0, 0, 0) !important;\r\n    }\r\n  \r\n    ::ng-deep .mat-tab-label {\r\n      // background-color: rgb(238, 180, 23) !important;\r\n      height: 30px  !important;\r\n      opacity:unset !important;\r\n      padding-inline: 1% !important;\r\n    }\r\n  \r\n    ::ng-deep .mat-tab-label.mat-tab-label-active {\r\n      min-width: 25px !important;\r\n      padding: 5px 10px;\r\n        background-color: #12127c;\r\n        color: white;\r\n        font-weight: 700;\r\n        opacity: unset;\r\n        border-top-left-radius: 5px;\r\n        border-top-right-radius: 5px;\r\n    }\r\n    ::ng-deep .mat-tab-label {\r\n      min-width: 25px !important;\r\n      padding: 5px;\r\n      background-color: transparent;\r\n      color: black;\r\n      font-weight: 700;\r\n    }\r\n  }\r\n  \r\n  ::ng-deep .mat-tab-body-content {\r\n    overflow-x: hidden !important;\r\n  }\r\n  \r\n\r\n.doller {\r\n    position: absolute;\r\n    top: -11px;\r\n    left: 15%;\r\n}\r\n.textCenter {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n.text-success {\r\n    color: #5dd077 !important;\r\n}\r\n.text-danger {\r\n    color: #da606c !important;\r\n}\r\n\r\n.gui_ellipsis {\r\n    font-weight: 600;\r\n    max-width: 70%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n}\r\n\r\n.pipeline_ellipsis {\r\n    max-width: 89%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    position: relative;\r\n    top: 8%;\r\n    left: 1%;\r\n    padding-right: 1%;\r\n}\r\n\r\n.trans_ellipsis {\r\n    max-width: 74%;\r\n    white-space: nowrap;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    position: relative;\r\n    top: 11%;\r\n    padding-right: 1%;\r\n}\r\n.active_card {\r\n    border-left: 4px solid #07a36e;\r\n}\r\n.progress_card {\r\n    border-left: 4px solid #ffc107;\r\n}\r\n.iconPointer:hover {\r\n    pointer-events: all;\r\n}\r\n.arrow_source {\r\n    left: 5%;\r\n    width: 97%;\r\n    height: 2px;\r\n    background-color: grey;\r\n    position: relative;\r\n    top: 36%;\r\n}\r\n.arr_chev {\r\n    position: relative;\r\n    text-align: right !important;\r\n    right: -98%;\r\n    color: grey;\r\n    top: -9px;\r\n}\r\n.failed_card {\r\n    border-left: 4px solid #da606c;\r\n}\r\n.healing_card {\r\n    border-left: 4px solid #f5a700;\r\n}\r\n\r\n.border-gradient {\r\n    border-left: 4px solid !important;\r\n    border-image-slice: 1;\r\n    border-block: 0;\r\n    border-right: 0;\r\n}\r\n.border-gradient-redgreen {\r\n    border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);\r\n}\r\n.copy_icon {\r\n    margin-left: 2%;\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n}\r\n\r\n.pipeline_label {\r\n    float: left;\r\n    padding-right: 11%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n.pipeline_feild {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.source_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n.source_feild {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.target_label {\r\n    float: left;\r\n    padding-right: 13%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n.target_feild {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.processor_label {\r\n    float: left;\r\n    padding-right: 7%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n.processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n.message_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n.message_feild {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.transaction_label {\r\n    float: left;\r\n    padding-right: 3%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n// .transaction_feild {\r\n//     float: left;\r\n//     width: 100%;\r\n// }\r\n\r\n.message_type_label {\r\n    float: left;\r\n    padding-right: 3%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n\r\n.message_type_feild {\r\n    width: 100%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    top: -6px;\r\n}\r\n.message_type_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n.message_type {\r\n    width: 100%;\r\n    height: 30px;\r\n    position: relative;\r\n}\r\n\r\n.messagefield_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n.messagefield_feild {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.btnsdiv {\r\n    padding-left: 16%;\r\n}\r\n\r\n@media screen and (min-width: 900px) and (max-width: 1024px) {\r\n    .pipeline_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 8px;\r\n    }\r\n\r\n    .target_label {\r\n        float: left;\r\n        padding-right: 9%;\r\n        position: relative;\r\n        top: 8px;\r\n    }\r\n    .processor_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 8px;\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n    }\r\n    .processor_feild {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n\r\n    .message_label {\r\n        float: left;\r\n        padding-right: 1%;\r\n        position: relative;\r\n        top: 8px;\r\n    }\r\n\r\n    .transaction_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 8px;\r\n    }\r\n    // .transaction_feild {\r\n    //     float: left;\r\n    //     width: 100%;\r\n    // }\r\n    .message_type {\r\n        width: 53%;\r\n        height: 35px;\r\n        position: relative;\r\n    }\r\n    .message_type_margin {\r\n        margin-left: 1% !important;\r\n    }\r\n    .pipeline_ellipsis {\r\n        max-width: 85%;\r\n    }\r\n    .trans_ellipsis {\r\n        max-width: 65%;\r\n    }\r\n    .message_btns {\r\n        span {\r\n            padding: 0 !important;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 500px) and (max-width: 786px) {\r\n    .pipeline_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 0px;\r\n    }\r\n\r\n    .pipeline_feild {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .source_label {\r\n        float: left;\r\n        padding-right: 6%;\r\n        position: relative;\r\n        top: 0px;\r\n    }\r\n    .source_feild {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .target_label {\r\n        float: left;\r\n        padding-right: 9%;\r\n        position: relative;\r\n        top: 0px;\r\n    }\r\n    .target_feild {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .processor_label {\r\n        float: left;\r\n        padding-right: 1%;\r\n        position: relative;\r\n        top: 0px;\r\n        font-size: 12px;\r\n        font-weight: 700;\r\n    }\r\n    .processor_feild {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n\r\n    .message_label {\r\n        float: left;\r\n        padding-right: 1%;\r\n        position: relative;\r\n        top: 0px;\r\n    }\r\n    .message_feild {\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n    .transaction_label {\r\n        float: left;\r\n        padding-right: 2%;\r\n        position: relative;\r\n        top: 0px;\r\n    }\r\n    // .transaction_feild {\r\n    //     float: left;\r\n    //     width: 100%;\r\n    // }\r\n    .message_type {\r\n        width: 86%;\r\n        height: 35px;\r\n        position: relative;\r\n    }\r\n\r\n    .reset_btn {\r\n        padding-inline: 13% !important;\r\n    }\r\n\r\n    .gui_ellipsis {\r\n        font-weight: 600;\r\n        width: 65%;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .message_type_margin {\r\n        margin-left: 1% !important;\r\n    }\r\n    .pipeline_ellipsis {\r\n        max-width: 81%;\r\n    }\r\n    .trans_ellipsis {\r\n        max-width: 52%;\r\n    }\r\n    .message_btns {\r\n        span {\r\n            padding: 0 !important;\r\n        }\r\n    }\r\n}\r\n\r\n.rightalign {\r\n    float: right;\r\n    padding-right: 60px;\r\n    padding-top: 10px;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {\r\n    height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n    top: 0;\r\n    height: 0px !important;\r\n    overflow: hidden;\r\n}\r\n\r\n.text-green {\r\n    color: green;\r\n}\r\n.text-red {\r\n    color: red;\r\n}\r\n\r\n::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {\r\n    position: absolute;\r\n    // width: 170% !important;\r\n    background: #fff;\r\n    height: auto;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n    box-sizing: border-box;\r\n    font-size: 12px;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog {\r\n    max-width: 97% !important;\r\n    max-height: 60% !important;\r\n    height: 60% !important;\r\n    margin: auto !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.date_control_style {\r\n    width: 100%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 2%;\r\n    // padding-block: 3%;\r\n}\r\n.autocomplete-container .suggestions-container {\r\n    position: absolute;\r\n\r\n    background: #fff;\r\n    height: auto;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n    box-sizing: border-box;\r\n    font-size: 12px;\r\n}\r\n\r\n::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {\r\n    position: absolute;\r\n    // width: 170%;\r\n    background: #fff;\r\n    height: auto;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n    box-sizing: border-box;\r\n    font-size: 12px;\r\n}\r\n\r\n.messagestatus {\r\n    position: relative;\r\n    top: -3px;\r\n}\r\n// .transaction_feild {\r\n//     float: left;\r\n//     font-size: $fontsize;\r\n//     // width: 73%;\r\n//     // margin-left: 17%;\r\n// }\r\n\r\n.dot {\r\n    height: 19px;\r\n    width: 21px;\r\n    background-color: #17a0b4 !important;\r\n    border-radius: 100%;\r\n    display: inline-block;\r\n}\r\n.name_feild {\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    float: left;\r\n    font-size: $fontsize;\r\n    height: $inputHeight;\r\n    padding-left: 5px;\r\n    input::placeholder {\r\n        font-size: $fontsize;\r\n    }\r\n}\r\n.name_feild::placeholder {\r\n    font-size: $fontsize;\r\n}\r\n\r\n::ng-deep.badmessagereprocess .modal-dialog .modal-content .modal-footer {\r\n    display: unset !important;\r\n    flex-wrap: wrap !important;\r\n    align-items: center !important;\r\n    justify-content: flex-end !important;\r\n    padding: 0.3rem !important;\r\n    border-top: 1px solid #dee2e6 !important;\r\n    border-bottom-right-radius: calc(0.3rem - 1px) !important;\r\n    border-bottom-left-radius: calc(0.3rem - 1px) !important;\r\n}\r\n\r\n::ng-deep.badmessagereprocess .modal-dialog {\r\n    max-width: 97% !important;\r\n    max-height: 60% !important;\r\n    height: 60% !important;\r\n    margin: auto !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n::ng-deep.monaco-editor\r\n{\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: -15px!important;\r\n    right: 0;\r\n}\r\n\r\n\r\n.transaction_feild{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 9.5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n  // width: 73%;\r\n  // margin-left: 17%;\r\n}\r\n.badmsg_name_text{\r\n    font-size: 12px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 90% !important;\r\n    display: inline-block;\r\n  }\r\n  .badmsg_text{\r\n    color: black;\r\n      top: 7px;\r\n  }\r\n\r\n  ::ng-deep.msgrep.mat-mdc-checkbox {\r\n    height: 16px;\r\n    width: 16px;\r\n    position: relative;\r\n    right: 3%;\r\n    bottom: 9%;\r\n    .mdc-checkbox {\r\n      width: 16px;\r\n      height: 16px;\r\n      .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n        border-color: $btn-color;\r\n        background-color: $btn-color;\r\n      }\r\n      .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n        color: white;\r\n    }\r\n    }\r\n    .mdc-checkbox__background{\r\n      height: 16px;\r\n      width: 16px;\r\n    }\r\n  }\r\n  ::ng-deep.msgreplist.mat-mdc-checkbox {\r\n    padding-left: 0 !important;\r\n    padding-right: 0px !important;\r\n    .mdc-checkbox {\r\n        width: 16px;\r\n        height: 16px;\r\n        .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n          border-color: $btn-color;\r\n          background-color: $btn-color;\r\n        }\r\n        .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n          color: white;\r\n      }\r\n      }\r\n    .mdc-checkbox__background{\r\n      height: 16px !important;\r\n      width: 16px !important;\r\n    }\r\n  }\r\n  .custom-autocomplete-input {\r\n    /* Add styles to make the input field resemble an autocomplete component */\r\n    border-radius: 5px;\r\n    border: 1px solid #f2f4f7;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.21); /* Add box shadow */\r\n    font-size: $fontsize;\r\n    font-size: $fontsize;\r\n\theight: 9.5vh;\r\n\tfloat: left;\r\n\twidth: 100%;\r\n}\r\n\r\n::ng-deep.myCustomModalViewfileBadMessage {\r\n  .modal-dialog {\r\n    max-width: 84vw !important;\r\n    width: 84vw !important;\r\n    max-height: 77vh !important;\r\n    height: 75vh !important;\r\n    padding: 0 !important;\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n    left: 2% !important;\r\n    top: 0% !important;\r\n    margin: 0 !important;\r\n  }\r\n  \r\n  .modal-content {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    overflow: hidden !important;\r\n    height:77vh;\r\n  }\r\n  \r\n  .modal-body {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    overflow: hidden !important;\r\n    height: 64vh !important;\r\n  }\r\n  \r\n  // Fix content overflow inside FileViewExplorer\r\n  .pdf-container {\r\n    max-width: 100% !important;\r\n    overflow: auto !important;\r\n    overflow-x: hidden !important;\r\n    height: 64vh !important;\r\n    .monaco-editor-containerr{\r\n        height: 64vh !important;\r\n    }\r\n  }\r\n  \r\n  // Fix Monaco editor parent div with 77vh height - override inline style\r\n  .modal-body > div[style*=\"77vh\"] {\r\n    height: 64vh !important;\r\n    overflow-x: auto !important;\r\n    overflow-y: auto !important;\r\n  }\r\n  \r\n  \r\n  // Fix Monaco editor overflow\r\n  ngx-monaco-editor {\r\n    max-width: 100% !important;\r\n    width: 100% !important;\r\n    \r\n    .editor-container {\r\n      max-width: 100% !important;\r\n      overflow: hidden !important;\r\n    }\r\n  }\r\n  \r\n  // Fix hardcoded widths in FileViewExplorer content\r\n  pdf-viewer {\r\n    max-width: 100% !important;\r\n    width: 100% !important;\r\n  }\r\n  \r\n  // Override inline styles with 60vw width\r\n  div[style*=\"60vw\"] {\r\n    max-width: 100% !important;\r\n    width: 100% !important;\r\n  }\r\n  \r\n  // Ensure modal-body content doesn't overflow\r\n  .modal-body > div {\r\n    max-width: 100% !important;\r\n    width: 100% !important;\r\n    overflow-x: auto !important;\r\n    overflow-y: auto !important;\r\n  }\r\n}\r\n  ::ng-deep.myCustomModalClass.badMessageViewModal{\r\n    width: 88vw !important;\r\n    max-width: 88vw !important;\r\n    left:12% !important;\r\n    top: 16% !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
